import React from 'react'
import Footer from '../components/footerComponent/footer'
import Settings from '../components/settingsComponent/settingsComponent'
import Header from '../components/headerComponent/header'
import {Layout} from 'antd';

export default function SettingsPage() {
    return (
        <Layout>
            <Header/>
            <Settings/>
            <Footer/>
        </Layout>
    );
};